<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon" src="@/assets/share/home/back.png"></van-col>
                <van-col span="12">
                    <div class="banner-title">隐私设置</div>
                </van-col>
                <van-col span="6">
                    <div class="save" @click="save">保存</div>
                </van-col>
            </van-row>
        </div>
        <div class="user-info">
            <div>
                <img class="user-img" :src="user.userAvatar ? user.userAvatar : defaultImg">
            </div>
            <div class="user-name">{{remark ? remark : user.userName}}</div>
            <div class="privilege-pro">你需要至少选择一项数据与TA共享</div>
        </div>
        <div class="privilege-box">
            <div class="privilege-item">
                <span class="privilege-text">身体状态</span>
                <div class="p-check">
                    <van-checkbox v-model="statusPrivilege" checked-color="#20D38F" shape="square"></van-checkbox>
                </div>
            </div>
            <div class="privilege-item">
                <span class="privilege-text">运动记录</span>
                <div class="p-check">
                    <van-checkbox v-model="sportPrivilege" checked-color="#20D38F" shape="square"></van-checkbox>
                </div>
            </div>
            <div class="privilege-item">
                <span class="privilege-text">心脏健康</span>
                <div class="p-check">
                    <van-checkbox v-model="ecgPrivilege" checked-color="#20D38F" shape="square"></van-checkbox>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Toast} from 'vant'

    export default {
        name: 'privilege',
        data() {
            return {
                defaultImg: require('@/assets/share/home/noImg.png'),
                user: {},
                applicationInformation: '我是',
                remark: localStorage.hasOwnProperty('remark') ? localStorage.getItem("remark") : '',
                privilege: '全部',
                statusPrivilege: localStorage.getItem("statusPrivilege") == 1 ? true : false,
                ecgPrivilege: localStorage.getItem("ecgPrivilege") == 1 ? true : false,
                sportPrivilege: localStorage.getItem("sportPrivilege") == 1 ? true : false,
                type: '',
            }
        },
        mounted() {
            this.user = JSON.parse(localStorage.getItem("addUser"));
            this.type = this.$route.params.type;
        },
        methods: {
            back() {
                this.$router.back();
            },
            save() {
                if (!this.statusPrivilege && !this.ecgPrivilege && !this.sportPrivilege) {
                    Toast('至少选择一项数据');
                    return
                }
                localStorage.setItem("statusPrivilege", this.statusPrivilege ? '1' : '0');
                localStorage.setItem("ecgPrivilege", this.ecgPrivilege ? '1' : '0');
                localStorage.setItem("sportPrivilege", this.sportPrivilege ? '1' : '0');
                this.back();
            }
        }
    }
</script>

<style scoped>
    .user-info {
        height: 137px;
        width: 375px;
        position: relative;
    }

    .user-img {
        width: 50px;
        height: 50px;
        border: 2px solid rgba(255,255,255,0.69);
        top: 20px;
        left: 163px;
        border-radius: 50%;
        position: absolute;
    }

    .user-name {
        position: absolute;
        width: 375px;
        font-size: 15px;
        top: 82px;
        color: #ffffff;
        opacity: 0.9;
        text-align: center;
    }

    .privilege-pro {
        color: #FFFFFF;
        opacity: 0.6;
        font-size: 12px;
        position: absolute;
        width: 375px;
        text-align: center;
        top: 105px;
    }

    .privilege-box {
        width: 345px;
        height: 156px;
        background: #202020;
        opacity: 1;
        border-radius: 6px;
        margin: 0 auto;
    }

    .privilege-item {
        border-bottom: 1px solid #000000;
        height: 52px;
        position: relative;
    }

    .privilege-text {
        color: #FFFFFF;
        opacity: 0.9;
        font-size: 14px;
        position: absolute;
        top: 18px;
        left: 20px;
    }

    .p-check {
        position: absolute;
        right: 15px;
        top: 18px;
    }

    /deep/ .van-icon {
        border-radius: 3px;
    }

    .save {
        color: #20D38F;
        font-size: 14px;
        float: right;
        margin-top: 10px;
        margin-right: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/views/share/privilege.vue